import { css } from "@emotion/css"

type Props = JSX.IntrinsicElements["fieldset"] & { legend?: string }

const FieldSet = ({ children, legend, ...props }: Props) => {
  return (
    <fieldset className={borderNone} {...props}>
      {legend && <legend className={style}>{legend}</legend>}
      {children}
    </fieldset>
  )
}

export default FieldSet

const style = css`
  padding-bottom: 8px;
  line-height: 14px;
`

const borderNone = css`
  border: none;
`
